/**
 * InquiryForm Component
 * --
 * 작성자 - owen
 * 작성일 - 2025 07 21 월요일
 * 마지막 수정일 - 2025 07 21 월요일
 */
import { Button, Flex, Input, Select } from 'antd';
import { Content, ModalLayout, Text } from 'components';
import React from 'react';

const InquiryForm = (props) => {
  /**
   * SECTION - Props
   */
  const {
    open = false,
    onClose = () => {},
    permission = 'SHOP',
    shops = [],
    userInfo = null,
    onCreate = () => {},
    onUpdate = () => {},
    onDelete = () => {},
    defaultData = null,
  } = props;
  /**!SECTION - Props */

  /**
   * SECTION - Init
   */
  const SUB_TYPE = {
    // 공통 문의
    DELIVERY: '배송', // 배송
    BULK: '대량문의', // 대량문의
    ORDER: '주문/결제', // 주문/결제
    ETC: '기타', //기타
    STORE: '매장', //매장

    // 1:1 문의
    JM_PAY: '제이엠페이 관련', // 제이엠페이 관련
    JM_PAY_REFUND: '환불 신청', // 환불 신청
    USER: '회원정보', // 회원정보
    SERVICE: '서비스', // 서비스
  };

  const INITIAL_VALUE = React.useMemo(() => {
    return {
      admin_id: userInfo.admin_id,
      shop_information_id: permission === 'ADMIN' ? null : 1,
      inquiry_type: 'ONEINQUIRY',
      inquiry_sub_type: null,
      inquiry_name: '',
      inquiry_content: '',
      is_secret: 'Y',
      inquiry_answer: null,
    };
  }, [userInfo, permission]);
  /**!SECTION - Init */

  /**
   * SECTION - Variable
   */

  /**!SECTION - Variable */

  /**
   * SECTION - Query Data
   */

  /**!SECTION - Query Data */

  /**
   * SECTION - Mutate
   */

  /**!SECTION - Mutate */

  /**
   * SECTION - State
   */
  const [inputValue, setInputValue] = React.useState(INITIAL_VALUE);
  /**!SECTION - State */

  /**
   * SECTION - Function
   */
  const handleSubmit = async (t) => {
    const {
      inquiry_id,
      admin_id,
      shop_information_id,
      inquiry_type,
      inquiry_sub_type,
      inquiry_name,
      inquiry_content,
      is_secret,
      inquiry_answer,
    } = inputValue;

    let res = false;
    switch (t) {
      case 'CREATE':
        res = await onCreate(inputValue);
        break;
      case 'UPDATE':
        res = await onUpdate({
          inquiry_id,
          admin_id,
          shop_information_id,
          inquiry_type,
          inquiry_sub_type,
          inquiry_name,
          inquiry_content,
          is_secret,
          inquiry_answer,
        });
        break;
      case 'DELETE':
        res = await onDelete({ inquiry_id, inquiry_answer });
        break;
      default:
        break;
    }
    if (res) {
      setInputValue(INITIAL_VALUE);
      onClose();
    }
  };
  /**!SECTION - Function */

  /**
   * SECTION - Hooks
   */
  React.useEffect(() => {
    if (defaultData) {
      setInputValue(defaultData);
    } else {
      setInputValue(INITIAL_VALUE);
    }
  }, [defaultData, INITIAL_VALUE]);
  /**!SECTION - Hooks */

  /**
   * SECTION - Render
   */
  return (
    <ModalLayout
      title={'문의하기'}
      open={open}
      onCancel={onClose}
      afterClose={() => {
        setInputValue(INITIAL_VALUE);
        onClose();
      }}
      closable
      width={500}
      footer={
        <Flex justify="space-between" align="center" gap={8}>
          {defaultData ? (
            <Button danger onClick={() => handleSubmit('DELETE')}>
              삭제
            </Button>
          ) : null}

          <Flex gap={8}>
            <Button onClick={onClose}>취소</Button>
            <Button
              type="primary"
              onClick={() => handleSubmit(defaultData ? 'UPDATE' : 'CREATE')}
            >
              {defaultData ? '수정하기' : '문의하기'}
            </Button>
          </Flex>
        </Flex>
      }
    >
      <Content maxWidth={'100%'} padding={0}>
        <Flex vertical gap={8}>
          {/* 문의 업체 */}
          {permission === 'ADMIN' ? (
            <Flex vertical gap={4}>
              <Text size={12} color={'#666666'}>
                문의 업체 <span style={{ color: '#FF4242' }}>*</span>
              </Text>
              <Select
                value={inputValue.shop_information_id}
                options={shops
                  .filter((item) => item.shop_information_id !== 1)
                  .map((item) => ({
                    label: item.shop_information_name,
                    value: item.shop_information_id,
                  }))}
                placeholder="문의할 업체를 선택해주세요."
                onChange={(e) =>
                  setInputValue((prev) => ({
                    ...prev,
                    shop_information_id: e,
                  }))
                }
              />
            </Flex>
          ) : null}

          {/* 문의 유형 */}
          <Flex vertical gap={4}>
            <Text size={12} color={'#666666'}>
              문의 유형 <span style={{ color: '#FF4242' }}>*</span>
            </Text>
            <Select
              value={inputValue.inquiry_sub_type}
              options={Object.entries(SUB_TYPE).map(([key, value]) => ({
                label: value,
                value: key,
              }))}
              placeholder="문의 유형을 선택해주세요."
              onChange={(e) =>
                setInputValue((prev) => ({
                  ...prev,
                  inquiry_sub_type: e,
                }))
              }
            />
          </Flex>

          {/* 문의명 */}
          <Flex vertical gap={4}>
            <Text size={12} color={'#666666'}>
              문의명 <span style={{ color: '#FF4242' }}>*</span>
            </Text>
            <Input
              value={inputValue.inquiry_name}
              placeholder="문의명을 입력해주세요."
              onChange={(e) =>
                setInputValue((prev) => ({
                  ...prev,
                  inquiry_name: e.target.value,
                }))
              }
            />
          </Flex>

          {/* 문의내용 */}
          <Flex vertical gap={4}>
            <Text size={12} color={'#666666'}>
              문의내용 <span style={{ color: '#FF4242' }}>*</span>
            </Text>
            <Input.TextArea
              value={inputValue.inquiry_content}
              rows={8}
              placeholder="문의내용을 입력해주세요."
              onChange={(e) =>
                setInputValue((prev) => ({
                  ...prev,
                  inquiry_content: e.target.value,
                }))
              }
            />
          </Flex>
        </Flex>
      </Content>
    </ModalLayout>
  );
  /**!SECTION - Render */
};

export default InquiryForm;
